import {
  Button,
  Form,
  Input,
  Switch,
  Radio,
  Select,
  InputNumber,
  Tag,
  Upload,
  Space,
  Row,
  Col,
  Cascader,
  message,
} from 'antd'
import { InboxOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons'
import TextArea from 'antd/lib/input/TextArea'
import './newSecondHand.css'
import { useEffect, useState } from 'react'
import { MyValidateMessages } from '../../utils/validateMessaage'
import UploadOnePicture from '../../components/upLoadOnePicture/uploadPicture'
import {
  changeMarketItem,
  changeShare,
  freshToken,
  getCategories,
  getMarketCategories,
  newShare,
  postMarketItem,
  shareDetail,
} from '../../api/api'
import UploadMultiplePicture from '../../components/uploadMultiplePicture/uploadMultiplePicture'
import { useLocation, useNavigate } from 'react-router-dom'
import UploadlistTypeMultiplePicture from '../../components/uploadlistTypeMultiplePicture/uploadlistTypeMultiplePicture'
import RichTextEditor from '../../components/richText/richText'
import UploadlistTypePicture from '../../components/uploadlistTypePicture/uploadlistTypePicture'

export default function NewSecondHand() {
  const [newSecondHand, setNewSecondHand] = useState([{ 1: 1 }, { 1: 1 }])
  const [data, setData] = useState()
  const [form] = Form.useForm()
  const [dictionary, setDictionary] = useState([]) //字典
  const [categoryName, setCategoryName] = useState({})
  const [contactImage, setContactImage] = useState('') //联系人图片
  const [images, setImages] = useState([]) //帖子图片

  const { Option } = Select
  const layout = {
    labelCol: {
      span: 2,
    },
    wrapperCol: {
      span: 8,
    },
  }
  const navigate = useNavigate()

  //向父组件传递图片网址
  const [url, setUrl] = useState()

  const setImgUrl = (newurl) => {
    setUrl(newurl)
    form.setFieldValue('image', newurl)
    // console.log(url);
  }
  //向父组件传递图片网址
  const [multipleImgUrl, setMultipleImgUrl] = useState([])

  //向父组件传递富文本内容
  const [richText, setRichText] = useState([])

  //获取初始字典初始数据
  useEffect(() => {
    getMarketCategories({}).then((res) => {
      setDictionary(res.data.data.rows)
      // console.log(JSON.stringify(res.data.data.Categories))
    })
  }, [])

  //编辑内容时的初始化
  const location = useLocation()
  const info = location?.state?.info ?? {}
  console.log(info, 'info')

  const findName = (list, target) => {
    for (let subList of list) {
      if (subList.id === target) {
        // console.log(subList.name)
        return subList.name
      }
      // if (subList.SubCategories) {
      //   let res = findName(subList.SubCategories, target)
      //   if (res) return res
      // }
    }
  }

  const cascaderChange = (val) => {
    const id = val.pop()
    // console.log(dictionary,id);
    const name = findName(dictionary, id)
    console.log(id, name)
    setCategoryName({ id: id, name: name })
    console.log(form.getFieldValue('category_id'))
    form.setFieldValue('category_id', id)
  }

  const wait = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(categoryName)
      }, 300)
    })
  }

  //设置cascader的展示内容
  const displayRender = () => {
    // console.log(categoryName);
    // console.log(label, options)
    return <span key={categoryName.id}>{categoryName.name}</span>
  }

  //初始化cascader，再获取一次dictionary保证dictionary不为空
  useEffect(() => {
    if (location.state && location.state.state === 'edit') {
      console.log('edit')
      setData(info)
      setContactImage(info.image)
      const initImages = info?.images.map((item, _) => {
        return {
          origin: item,
          thumbnail: item,
        }
      })
      setImages(initImages)
      getMarketCategories().then((res) => {
        // console.log(res);
        const list = res.data.data.rows
        //将category数字转化成文字
        const category_id = info.category_id
        const Category_name = findName(list, category_id)
        setCategoryName({ id: category_id, name: Category_name })
        form.setFieldsValue(info)
      })
    }
  }, [])

  const onFinish = (values) => {
    form.setFieldValue('image', contactImage)
    console.log(contactImage)
    form.setFieldValue('category_id', categoryName.id)
    form.setFieldValue((e) => {
      console.log('formfiled:', e)
    })
    const newImageList = images.map((item, index) => {
      return item.origin
    })

    form.setFieldValue('images', newImageList)
    form.validateFields().then((res) => {
      //定义选填内容
      // console.log(res.contents)
      // console.log(images)

      //将上传图片组件返回的对象转化为字符串

      // console.log('content data:', res)
      const putparams = {
        ...res,
        images: newImageList,
        id: data?.id,
      }

      const postparams = {
        ...res,
        images: newImageList,
        //新增默认上架
        is_visible: 1,
      }
      console.log(putparams, postparams)
      if (location?.state?.state === 'edit') {
        changeMarketItem(putparams)
          .then((res) => {
            console.log(res)
            message.success('编辑内容成功！')
            navigate('/secondHand', { replace: true })
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        postMarketItem(postparams)
          .then((res) => {
            console.log(res)
            message.success('新建内容成功！')
            navigate('/secondHand', { replace: true })
          })
          .catch((err) => {
            console.log(err)
          })
      }
    })
  }

  const cancelSubmit = () => {
    navigate('/secondHand', { replace: true })
  }

  const add = () => {
    setNewSecondHand([...newSecondHand, {}])
  }
  const deleteContent = (idx) => {
    newSecondHand.map((info, index) => {
      if (index === idx) {
        newSecondHand.splice(idx, 1)
        setNewSecondHand(() => {
          return [...newSecondHand]
        })
        console.log('delete:', info)
      }
    })
  }

  const [fresh, setFresh] = useState(false)
  useEffect(() => {
    console.log('fileList', fresh)
  }, [fresh])

  //信息选填的图片的URL传递
  const changeMultipleImg = (index) => (newUrl) => {
    console.log('newUrl', newUrl)
    setFresh((pre) => !pre)
    setMultipleImgUrl((pre) => {
      // console.log('the initial img url arr',pre)
      // console.log(newUrl)
      // console.log(pre,pre.images);
      const newData = pre[index] ?? []
      newData.push(newUrl)
      // console.log(newData)
      pre[index] = newData
      return pre
    })
  }

  return (
    <div className="newSecondHand">
      <p className="newSecondHandTitle">帖子信息</p>
      <Form
        {...layout}
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={MyValidateMessages}
        form={form}
        initialValues={data ?? {}}
      >
        <Row>
          <Col span={12}>
            {/* 内容标题 */}
            <Form.Item
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 16,
              }}
              name="title"
              label="帖子标题"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="上限50字" />
            </Form.Item>
          </Col>
          <Col span={7}>
            {/* 房屋数量 */}
            <Form.Item
              labelCol={{ span: 7 }}
              name="is_hand_delivered"
              label="是否面交"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select placeholder="请选择">
                <Select.Option value={1}>是</Select.Option>
                <Select.Option value={0}>否</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          {/* 是否部分可见 */}
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 10,
              }}
              label="价格"
            >
              {' '}
              <Form.Item
                noStyle
                name="price"
                rules={[
                  {
                    type: 'number',
                    required: true,
                  },
                ]}
              >
                <InputNumber
                  noStyle
                  style={{ width: '200px' }}
                  placeholder="请填写租金（必填项）"
                />
              </Form.Item>
              <span className="ant-form-text">£</span>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 6,
              }}
              label="优先级"
              name="priority"
              rules={[
                {
                  type: 'number',
                  required: true,
                  min: 0,
                  max: 99,
                },
              ]}
            >
              <InputNumber
                style={{ width: '150px' }}
                placeholder="输入0-99的整数"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            {' '}
            {/* 内容分类 */}
            <Form.Item
              name="category_id"
              label="内容分类"
              hasFeedback
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 10,
              }}
              rules={[
                {
                  required: true,
                  validator: async (rule, value) => {
                    // console.log(value);
                    const data = await wait()
                    // console.log(data);
                    if (data?.id ?? false) {
                      // console.log("yes");
                      return Promise.resolve()
                    } else {
                      console.log('error')
                      return Promise.reject(new Error('内容分类是必填项！'))
                    }
                  },
                },
              ]}
            >
              <Cascader
                options={dictionary}
                allowClear={false}
                fieldNames={{
                  value: 'id',
                  label: 'name',
                }}
                displayRender={displayRender}
                onChange={cascaderChange}
                key={categoryName}
                placeholder="请选择"
              ></Cascader>
            </Form.Item>
          </Col>
          <Col span={12}>
            {' '}
            {/* 新旧程度 */}
            <Form.Item
              label="新旧程度"
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 6,
              }}
              name="condition"
              rules={[
                {
                  max: 8,
                },
              ]}
            >
              <Input
                style={{ width: '300px' }}
                placeholder="请输入新旧程度描述，上限8字"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            {' '}
            {/* 新旧程度 */}
            <Form.Item
              label="联系人"
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 6,
              }}
              name="contact_person"
              rules={[
                {
                  max: 8,
                },
              ]}
            >
              <Input style={{ width: '300px' }} placeholder="请输入联系人" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="联系方式"
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 6,
              }}
              name="contact_top"
              rules={[
                {
                  max: 20,
                },
              ]}
            >
              <Input style={{ width: '300px' }} placeholder="请输入联系方式" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 18,
              }}
              label="物品介绍"
              name="description"
              rules={[{ type: 'string', required: true, max: 300 }]}
            >
              <TextArea
                style={{ width: 500, height: 200 }}
                placeholder="请填写内容，上限300字"
              />
            </Form.Item>
          </Col>
          <Col span={12}></Col>

          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 18,
              }}
              name="contact_bottom"
              label="联系方式"
              style={{ margin: '20px 0' }}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="联系方式的文字填写框、图片上传项都是必填。" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              style={{ marginTop: 10 }}
              name="image"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <UploadlistTypePicture
                imageName="联系人方式图片"
                deliverUrl={setContactImage}
                image={info?.image ?? ''}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* 房源图片 */}
        <Form.Item
          label="帖子图片"
          labelCol={{ span: 2 }}
          name="images"
          rules={[{ required: true }]}
        >
          <UploadlistTypeMultiplePicture
            max={30}
            name="帖子图片"
            deliverUrl={setImages}
            images={
              info?.images?.map((item, _) => {
                return {
                  origin: item,
                  thumbnail: item,
                }
              }) ?? []
            }
          />
        </Form.Item>
        <Form.Item
          wrapperCol={{
            ...layout.wrapperCol,
            offset: 20,
            span: 24,
          }}
        >
          <div className="buttonGroup">
            <Button onClick={cancelSubmit}>取消</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: '20px' }}
              onClick={onFinish}
            >
              提交
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}
